import { render, staticRenderFns } from "./Sales_Date.vue?vue&type=template&id=afc36d5c&scoped=true&"
import script from "./Sales_Date.vue?vue&type=script&lang=js&"
export * from "./Sales_Date.vue?vue&type=script&lang=js&"
import style0 from "./Sales_Date.vue?vue&type=style&index=0&id=afc36d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc36d5c",
  null
  
)

export default component.exports